import { ElMessage, ElMessageBox } from "element-plus";
import Auth from "../../../../utils/auth";
import Api_Login from "../../../../api/System/Login";
import router from '../../../../router';
import Loading from "../../../../utils/Loading"; //获取加载组件

import { markRaw } from 'vue'
import { WarnTriangleFilled } from '@element-plus/icons-vue'


export default {
	name: 'ModuleBox',
	components: {

	},
	data(){
		return{
			ValueData:'111',
			Info:JSON.parse(Auth.getInfo()),

			AdminName:'',
			Name:"",
			Department:"",
			RoleJsonData:[],
		}
	},
	methods:{
		Logout(){			
			ElMessageBox({
				title: '系统提示',
				message: "是否确认退出系统吗？",
				type: 'warning',
				icon: markRaw(WarnTriangleFilled),
				confirmButtonText: "确认退出",
			}).then(async (response) => {
				try {
					Loading.LoadingShow();
				
					let RequestData = {};
					let ReturnData = Api_Login.CheckOut(RequestData);
					ReturnData.then(response => {
						Loading.LoadingHide();
						//console.log(response);

						let State = response['Data'][0].State;
						let Message = response['Data'][0].Message;
						if(State == 'Success'){
							Auth.removeToken();
							Auth.removeInfo();
							router.replace({path:'/Login'});
							ElMessage.success(Message);
						}else{
							ElMessage.error(Message);
						}
					})
				}catch(err){
					//console.log(err);
				}
			})
			.catch((response) => {
				//console.log(response);
			})
		},
		Admin_Update_Password_Show(){
			this.$emit("Admin_Update_Password_Show",true);
		},
		Admin_Update_KeyCode_Show(){
			this.$emit("Admin_Update_KeyCode_Show",true);
		},
	},
	mounted(){
		this.AdminName = this.Info.AdminName;
		this.Name = this.Info.Info?.Name;
		this.Department = this.Info.Info?.Department;

		this.RoleJsonData = this.Info.Role;
		
	},
    watch: {

    },
    emits:{
		"Admin_Update_Password_Show":null,
		"Admin_Update_KeyCode_Show":null,
    }
}